import { useReactFlow } from "reactflow";
import { openFile } from "../api";
import { useLineageContext, useLineageDispatch } from "../context/LineageProvider";
import { setMinRange, setNodeCount, setSelectedTable } from "../context/LineageSlice";
import {
  calculateMinLevel,
  calculateNodeCount,
  setHighlightedTableConnections,
} from "../graph";

/**
 * Shared "select this table" handler. Used by both `TableNode` (clicking
 * the table header / body) and `ColumnNode` in show-columns mode
 * (clicking a column row that wasn't added by CLL). The same effects
 * fire in both cases: highlight the table's lineage edges, mark it as
 * the selected table, recompute layout bounds, open the source file.
 *
 * See `CLICK-SEMANTICS.md` for the full contract.
 */
export function useSelectTable() {
  const flow = useReactFlow();
  const lineageDispatch = useLineageDispatch();
  const {
    state: { leftExpansion, rightExpansion },
  } = useLineageContext();
  return async (table: string, url?: string) => {
    const nodes = flow.getNodes();
    const edges = flow.getEdges();
    lineageDispatch(setMinRange(calculateMinLevel(nodes, edges, table)));
    lineageDispatch(
      setNodeCount(
        await calculateNodeCount(nodes, edges, table, leftExpansion, rightExpansion)
      )
    );
    setHighlightedTableConnections(flow, table);
    lineageDispatch(setSelectedTable(table));
    if (url) {
      openFile(url);
    }
  };
}
